export default __webpack_public_path__ + "static/media/mc_tube.9e6419a3.svg";